__turbopack_context__.v({
  "embla": "listing-carousel-module-scss-module__esqdIa__embla",
  "embla__buttons": "listing-carousel-module-scss-module__esqdIa__embla__buttons",
  "embla__container": "listing-carousel-module-scss-module__esqdIa__embla__container",
  "embla__slide": "listing-carousel-module-scss-module__esqdIa__embla__slide",
  "embla__slide__img": "listing-carousel-module-scss-module__esqdIa__embla__slide__img",
  "embla__viewport": "listing-carousel-module-scss-module__esqdIa__embla__viewport",
  "embla_bookmark": "listing-carousel-module-scss-module__esqdIa__embla_bookmark",
  "embla_bookmarkIcon": "listing-carousel-module-scss-module__esqdIa__embla_bookmarkIcon",
  "embla_bookmarkIcon__isBookmarked": "listing-carousel-module-scss-module__esqdIa__embla_bookmarkIcon__isBookmarked",
  "embla_isNew": "listing-carousel-module-scss-module__esqdIa__embla_isNew",
  "embla_relativeDate": "listing-carousel-module-scss-module__esqdIa__embla_relativeDate",
});
